<template>
  <span>
    <span class="d-none d-md-inline">
      <slot></slot>
      <!-- this is just an indicator that user is in pro, not an actionable item like -->
      <span class="pro-badge" v-if="pro">Pro</span>
    </span>

    <span class="d-md-none username">
      <i class="far fa-user"></i>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    pro: { default: false }
  }
}
</script>

<style scoped lang="scss">
.username {
  display: flex;
  font-weight: 600;

  .pro-badge {
    margin-left: 0.5rem;
    height: 1.6rem;
    font-size: 0.7rem;
  }
}
</style>
